import React, { useEffect } from "react"
import { Link, navigate } from "gatsby"
import { initializeIcons } from "@uifabric/icons"

import SEO from '../components/seo';
import { LANDING_URL } from '../models/api';

import theme from '../theme'
import { ThemeProvider } from '@material-ui/core/styles';

import { useSelector } from "react-redux";

initializeIcons()

export default function Index() {
  // Global state
  const { state } = useSelector(state => {
    return {
      state: state
    }
  })

  // Redirect to dashboard if the user is authenticated
  useEffect(() => {
    if (state && state.isAuthenticated) {
      navigate("/dashboard")
    }
  }, [state]);

  useEffect(() => {
    //window.location.href = LANDING_URL;
  }, [])


  return (
    <ThemeProvider theme={theme}>
      <SEO title='' />
      <div className="container-fluid">
        <div className="row">
          <div className="col" style={styles.topMenuBlock}>
            <Link to="/login/" style={styles.link}>Login</Link>
            <Link to="/register/" style={styles.link}>Register</Link>
          </div>

        </div>
        <div className="row">
          <div className="col-4 offset-4" style={{textAlign:"center",marginTop:"150px"}}>
            <h1>Cert-checker UI</h1>
          </div>
        </div>
      </div>
    </ThemeProvider>
  )
}

const styles = {
  link: {
    padding: "0 5px 0 15px",
    color: "#222",
  },
  topMenuBlock: {
    textAlign: "right",
    background: "#efefef",
    paddingTop: "5px",
    paddingBottom: "5px"
  }
}
